import { render } from "./mCase.vue?vue&type=template&id=180eda44&scoped=true"
import script from "./mCase.vue?vue&type=script&lang=js"
export * from "./mCase.vue?vue&type=script&lang=js"

import "./mCase.vue?vue&type=style&index=0&id=180eda44&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180eda44"]])

export default __exports__